__turbopack_context__.v({
  "mobileViewContainer": "MobileViewContainer-module__I0z_aG__mobileViewContainer",
  "modalBody": "MobileViewContainer-module__I0z_aG__modalBody",
  "modalHeader": "MobileViewContainer-module__I0z_aG__modalHeader",
  "modalHeight": "MobileViewContainer-module__I0z_aG__modalHeight",
  "titleWithIcon": "MobileViewContainer-module__I0z_aG__titleWithIcon",
});
